import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'

import {buildLogTimelineHint} from '../../../../Hints/HintItems/Hints.buildOverview'
import {useHint} from '../../../../Hints/Hints.hooks'
import {stringifyHintId} from '../../../../Hints/Hints.types'

import type {Props} from './TimelineStageButton.types'

import styles from './TimelineStageButton.css'

export default function TimelineStageButton({
  className,
  onClick,
  children,
  'aria-label': ariaLabel,
}: Props) {
  useHint(buildLogTimelineHint)
  return (
    <Button
      data-hint-container-id={stringifyHintId(buildLogTimelineHint.id)}
      aria-label={ariaLabel}
      text
      className={classNames(className, styles.button)}
      onClick={onClick}
      data-test-timeline-stage-button
    >
      {children}
    </Button>
  )
}
